import {Input, Radio} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../styles/discount-form.styles";

export function DiscountCodeCustomersFormFieldV2() {
  const {control, clearErrors, watch} = useFormContext();
  const customersType = watch("customersType");

  return (
    <StyledDiscountFormContainer>
      <div className="form-header">Customers</div>
      <div className="form-content">
        <StyledDiscountFormItem
          style={{marginBottom: customersType === "limited" ? "12px" : 0}}
        >
          <Controller
            control={control}
            name="customersType"
            render={({field: {onChange, value, onBlur, ref}, fieldState: {error}}) => (
              <>
                <Radio.Group
                  value={value}
                  onBlur={onBlur}
                  ref={ref}
                  onChange={(e) => {
                    if (e.target.value === "unlimited") {
                      clearErrors("usage_limit");
                    }
                    onChange(e.target.value);
                  }}
                >
                  <Radio value={"limited"}>Limited</Radio>
                  <Radio value={"unlimited"}>Unlimited</Radio>
                </Radio.Group>
                {error && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
        {customersType === "limited" && (
          <StyledDiscountFormItem style={{marginBottom: 0}}>
            <Controller
              control={control}
              name="usage_limit"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <>
                  <Input
                    status={error?.message ? "error" : ""}
                    onChange={onChange}
                    onBlur={onBlur}
                    size="large"
                    value={value}
                    placeholder="Number of customers needed"
                    ref={ref}
                  />
                  {error && (
                    <div role="alert" className="ant-form-item-explain-error">
                      {error.message}
                    </div>
                  )}
                </>
              )}
            />
          </StyledDiscountFormItem>
        )}
      </div>
    </StyledDiscountFormContainer>
  );
}
